<div class="ir-area ir-mask th-mask" *ngIf="inspection">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="updateInspection(editForm.value)">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ 'common.edit-properties' | translate : inspection }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'common.name' | translate }} *</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <validation-message
                  [validationControl]="editForm.controls.name"
                  [validationName]="'required'"
                  [errorMessage]="'common.required' | translate"
                ></validation-message>
                <input type="text" formControlName="name" placeholder="Your inspection name" class="ir-form-set" />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'common.description' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <textarea
                  formControlName="description"
                  rows="3"
                  placeholder="{{ 'inspections.placeholders.description' | translate }}"
                  class="ir-form-set"
                ></textarea>
              </div>
            </td>
          </tr>
          <tr [permissions]="[['visible', 'manage.inspection.status']]">
            <td class="margin-big">
              <h2>
                <span>{{ 'common.status' | translate }} *</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <select name="status" class="ir-form-set" formControlName="status">
                  <option *ngFor="let s of statusListAugmented" [value]="s">{{ s | inspectionstatus }}</option>
                </select>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'common.report-cover' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <select name="coverImage" class="ir-form-set" formControlName="coverImage">
                  <option *ngFor="let i of coverImages" [value]="i.id">{{ i.name || i.filename }}</option>
                </select>
              </div>
            </td>
          </tr>
          <tr *ngIf="categories?.length">
            <td class="margin-big">
              <h2>
                <span>{{ 'common.category' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <select name="category" class="ir-form-set" formControlName="category">
                  <option [ngValue]="null" value="0"></option>
                  <option *ngFor="let category of categories" [value]="category.value">
                    {{ category.label | translate }}
                  </option>
                </select>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'common.hourly-rate' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <input
                  name="hourlyRate"
                  class="ir-form-set"
                  type="number"
                  formControlName="hourlyRate"
                  appNumberRange
                  [min]="0"
                  [max]="2147483647"
                />
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'common.currency' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <select name="currency" class="ir-form-set" formControlName="currency">
                  <option *ngFor="let currency of currencies" [value]="currency">{{ currency }}</option>
                </select>
              </div>
            </td>
          </tr>
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'inspections.template-used' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <input type="text" formControlName="tplName" class="ir-form-set" readonly="readonly" />
              </div>
            </td>
          </tr>
          <tr *ngIf="inspection?.creator">
            <td class="margin-big">
              <h2>
                <span>{{ 'inspection.creator' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <span>{{ inspection?.creator }}</span>
              </div>
            </td>
          </tr>
          <tr *ngIf="inspection?.dateOfCreation">
            <td class="margin-big">
              <h2>
                <span>{{ 'inspection.creationDate' | translate }}</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <span>{{ inspection?.dateOfCreation | formatDate }}</span>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="editForm.invalid"
            [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
            *ngIf="!processing"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-disabled ir-txt--right"
            type="submit"
            *ngIf="processing"
          >
            <span>{{ 'common.processing' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
